import { List, fromJS } from 'immutable';
import { FetchEmailAddressesActionTypes, AddEmailAddressActionTypes, RemoveEmailAddressActionTypes } from '../actions/EmailAddressActions';
import { handleActions } from 'flux-actions';
// @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
const initialState = new List();
export default handleActions({
  [FetchEmailAddressesActionTypes.SUCCESS](state, action) {
    return fromJS(action.payload.data);
  },
  [AddEmailAddressActionTypes.SUCCESS](state, action) {
    return state.push(action.payload.props);
  },
  [RemoveEmailAddressActionTypes.SUCCESS](state, action) {
    return state.filter(emailAddress => emailAddress !== action.payload.props);
  }
}, initialState);